import { Pipe, PipeTransform } from '@angular/core';

@Pipe({ name: 'jsonToStringPipe' })
export class JsonToStringPipe implements PipeTransform {
  transform(value: any): string {
    return JSON.stringify(value,null,2);
  }
}
